import { initialState } from '@/features/habitation/habitationSlice';
import { HabitationState } from '@/features/habitation/types';

export const loadHabitationState = (): HabitationState => {
  try {
    const serializedState = localStorage.getItem('habitationState');
    if (!serializedState) return initialState; // Fallback sécurisé
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Failed to load habitation state from localStorage:', e);
    return initialState;
  }
};

export const saveHabitationState = (state: HabitationState) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('habitationState', serializedState);
    console.log('✔️ State saved to localStorage');
  } catch (e) {
    console.warn('❌ Failed to save habitation state:', e);
  }
};
